import PropTypes from "prop-types";
import React, { useEffect, useState } from 'react';
import { Button, Modal, Accordion } from 'semantic-ui-react';
import { useTextResources, useMessageResources } from '../../language';
import { useCurrentHotel } from '../../hooks/useCurrentHotel';
import './style.css';
import TextList from '../shared/TextList';
import { buildAutoDescriptionForPolicy } from '../shared/reservationPolicy';

const ReservationPolicyUpdateConfirmationPopup = ({
    open,
    onApplyNewPolicy,
    onKeepCurrentPolicy,
    newPolicyDetails,
    controller
}) => {
    const text = useTextResources();
    const message = useMessageResources();
    const currentHotel = useCurrentHotel();
    const [isOpen, setIsOpen] = useState(open);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [params, setParams] = useState(null)

    useEffect(() => {
        if (controller) {
            window[controller] = async (action, params) => {
                switch (action) {
                    case "open":
                         if (params) {
                            setParams(params);
                         }
                        setIsOpen(true);
                        break;
                    case "close":
                        setIsOpen(false);
                        break;
                    default:
                        break;
                }
            }
        }
    }, [controller]);

    useEffect(() => {
        setIsOpen(open);
    }, [open]);

    const handleClosePopup = () => {
        setActiveIndex(-1);
        setIsOpen(false);
    };

    const handleApplyNewPolicy = () => {
        params?.onApplyNewPolicy?.()
        onApplyNewPolicy?.();
        handleClosePopup();
    };

    const handleKeepCurrentPolicy = () => {
        params?.onKeepCurrentPolicy?.()
        onKeepCurrentPolicy?.();
        handleClosePopup();
    };

    const handleAccordionClick = (e, titleProps) => {
        const { index } = titleProps;
        const newIndex = activeIndex === index ? -1 : index;
        setActiveIndex(newIndex);
    };

    return (
        <Modal
            size="small"
            open={isOpen}
            onClose={handleClosePopup}
            className='reservation-policy-update-confirmation-popup'>
            <Modal.Header>
                {text("PolicyChangeNotification")}
            </Modal.Header>
            <Modal.Content>
                {text("CancellationPolicyDifferentMessage")}
                <div style={{ marginTop: '10px' }}>
                    <Accordion>
                        <Accordion.Title
                            active={activeIndex === 0}
                            index={0}
                            onClick={handleAccordionClick}
                            style={{ cursor: 'pointer', color: '#1e70bf', textDecoration: 'underline' }}>
                            {text("ClickHereToViewDetails")}
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === 0}>
                             <div style={{ padding: 10 }}>
                                <div style={{ padding: 10 }}>
                                    {newPolicyDetails?.Name ?? params?.newPolicyDetails?.Name + ":"}
                                </div>
                                <TextList text={buildAutoDescriptionForPolicy(newPolicyDetails ?? params?.newPolicyDetails, message, text, currentHotel?.HotelParameter?.TimeZone)} />
                              </div>
                        </Accordion.Content>
                    </Accordion>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    negative
                    onClick={handleKeepCurrentPolicy}>
                    {text("DontChangePolicy")}
                </Button>
                <Button
                    positive
                    onClick={handleApplyNewPolicy}>
                    {text("ApplyNewPolicy")}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

ReservationPolicyUpdateConfirmationPopup.propTypes = {
    open: PropTypes.bool,
    onApplyNewPolicy: PropTypes.func,
    onKeepCurrentPolicy: PropTypes.func,
    newPolicyDetails: PropTypes.object,
    controller: PropTypes.string,
}

export default ReservationPolicyUpdateConfirmationPopup;
